import React, { Suspense, lazy } from 'react';

import ApiErrorBoundary from '@components/Common/Error/ApiErrorBoundary';
import InvestGrowthSummarySkeleton from '@components/Group/Portfolio/Skeleton/InvestGrowthSummarySkeleton';
import TimelineSkeleton from '@components/Group/Portfolio/Skeleton/TimelineSkeleton';

const InvestGrowthSummary = lazy(
  () => import('@components/Group/Portfolio/InvestGrowthSummary')
);

const Timeline = lazy(() => import('@components/Group/Portfolio/Timeline'));

/** 조합 관리 > 상세 > 포트폴리오 상세 > 성장정보 */
const GrowthInfo = () => {
  return (
    <>
      <ApiErrorBoundary>
        <Suspense fallback={<InvestGrowthSummarySkeleton />}>
          <InvestGrowthSummary />
        </Suspense>
      </ApiErrorBoundary>

      <ApiErrorBoundary>
        <Suspense fallback={<TimelineSkeleton />}>
          <Timeline />
        </Suspense>
      </ApiErrorBoundary>
    </>
  );
};

export default GrowthInfo;
